module.exports = __webpack_public_path__ + "static/media/okaib.39605ad1.png";